import { render, staticRenderFns } from "./QuoteList.vue?vue&type=template&id=0501d0e3&scoped=true&"
import script from "./QuoteList.vue?vue&type=script&lang=js&"
export * from "./QuoteList.vue?vue&type=script&lang=js&"
import style0 from "./QuoteList.vue?vue&type=style&index=0&id=0501d0e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0501d0e3",
  null
  
)

component.options.__file = "QuoteList.vue"
export default component.exports